import React from 'react'
import titleImg from '../../assets/images/title.png'
import mdot from '../../assets/images/mdot.png'
import './header.scss'


const Header = () => {
  return (
      <header> 
          <nav className='nav'> 

            <img className='nav__title-img' src={titleImg} alt="Freeway courtesy patrol"  width="362px" height="216px"/>

            <div className='nav__right'>
              <img className='nav__right-img' src={mdot} alt="Michigan Department of Transportation" width="200px" height="56px"/>

              <p className='nav__right-text '>
                <strong>Want to Learn More?</strong>
                <br />
                For more information about 
                <br />
                MDOT's Freeway Courtesy Patrol:
                <br />
                <a className='nav__right-link' href="http://www.michigan.gov/courtesypatrol" target='_blank' rel="noreferrer">michigan.gov/courtesypatrol</a>
               </p>
            </div>

          </nav>

          <div className="description">
            Were you recently assisted by the Freeway Courtesy Patrol? We'd like know how we're doing.
           <br />
            Please complete the form below to share your comments or thank a driver.
          </div>
      </header>
  )
}

export default Header
